var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9544 1.25H20.0456C30.3757 1.25 38.75 9.62427 38.75 19.9545V20.0455C38.75 30.3757 30.3757 38.75 20.0456 38.75H19.9544C9.62426 38.75 1.25 30.3757 1.25 20.0455V19.9545C1.25 9.62427 9.62426 1.25 19.9544 1.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9544 1.25H20.0456C30.3757 1.25 38.75 9.62427 38.75 19.9545V20.0455C38.75 30.3757 30.3757 38.75 20.0456 38.75H19.9544C9.62426 38.75 1.25 30.3757 1.25 20.0455V19.9545C1.25 9.62427 9.62426 1.25 19.9544 1.25Z",
    stroke: "#0076FF",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9544 1.25H20.0456C30.3757 1.25 38.75 9.62427 38.75 19.9545V20.0455C38.75 30.3757 30.3757 38.75 20.0456 38.75H19.9544C9.62426 38.75 1.25 30.3757 1.25 20.0455V19.9545C1.25 9.62427 9.62426 1.25 19.9544 1.25Z",
    stroke: "url(#paint0_linear_2024_3953)",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0667 12.9688L13.0042 27.0312",
    stroke: "#0076FF",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0042 12.9688L27.0667 27.0312",
    stroke: "#0076FF",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2024_3953",
    x1: 20,
    y1: 0,
    x2: 5.92179,
    y2: 30.6145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0076FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ACCC2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.f9609100cb1fe145a2bd4b59e38f288c.svg";
export { ForwardRef as ReactComponent };